/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Report stage can be any of the Trade Lifecycle stages.
 * @export
 */
export const ReportStage = {
    START_OF_DAY: 'start_of_day',
    PRE_TRADE: 'pre_trade',
    END_OF_DAY: 'end_of_day'
} as const;
export type ReportStage = typeof ReportStage[keyof typeof ReportStage];


export function instanceOfReportStage(value: any): boolean {
    for (const key in ReportStage) {
        if (Object.prototype.hasOwnProperty.call(ReportStage, key)) {
            if (ReportStage[key as keyof typeof ReportStage] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReportStageFromJSON(json: any): ReportStage {
    return ReportStageFromJSONTyped(json, false);
}

export function ReportStageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportStage {
    return json as ReportStage;
}

export function ReportStageToJSON(value?: ReportStage | null): any {
    return value as any;
}

export function ReportStageToJSONTyped(value: any, ignoreDiscriminator: boolean): ReportStage {
    return value as ReportStage;
}

